<template>
    <v-btn block class="wide-btn my-3" :class="{ 'wide-btn--text': !filled && !outlined }" :disabled="disabled"
        :loading="loading" :variant="variant" :elevation="0" height="46" :style="buttonStyle"
        @click.stop="handleClick">
        {{ text }}
    </v-btn>
</template>


<script>
export default {
    name: 'WideBtn',
    emits: ['click'],
    props: {
        color: {
            type: String,
            default: 'var(--v-primary-base)',
        },
        filled: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: 'Button text',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {},

    data() {
        return {};
    },

    methods: {
        handleClick() {
            if (!this.disabled && !this.loading) {
                this.$emit('click');
            }
        },
    },

    computed: {
        c() { return this.disabled ? 'var(--v-disabled-base)' : this.color },
        fgc() { return !this.outlined && this.filled ? '#fff' : this.c; },
        bgc() { return !this.outlined && this.filled ? this.c : 'transparent'; },
        variant() {
            if (this.outlined) {
                return 'outlined';
            }

            return this.filled ? 'flat' : 'text';
        },
        buttonStyle() {
            return {
                '--wide-btn-color': this.c,
                backgroundColor: this.bgc,
                borderColor: this.outlined ? this.c : undefined,
                color: this.fgc,
            };
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.wide-btn {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    text-transform: none;
}

.wide-btn--text {
    color: var(--wide-btn-color) !important;
}
</style>